export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-dna-line',
      tag: 'Digital Biology',
      title: 'Digital Biology & AI',
      desc: 'Harness artificial intelligence to design breakthrough therapies and decode molecular pathways. Our AI-driven biological systems accelerate drug discovery, optimize therapeutic targets, and transform pharmaceutical research through intelligent molecular engineering.',
      cta: 'Illuminate Pathways',
      accent: '#c9a84c',
    },
    {
      icon: 'ri-robot-2-line',
      tag: 'Enterprise AI',
      title: 'Digital Transformation',
      desc: 'Revolutionize organizational capabilities through intelligent automation and AI integration. We guide enterprises across Manufacturing, Finance, Healthcare, and Retail through comprehensive digital evolution that unlocks their innovation potential.',
      cta: 'Engineer Growth',
      accent: '#e8c87a',
    },
    {
      icon: 'ri-heart-pulse-line',
      tag: 'Health Tech',
      title: 'Digital Wellness',
      desc: 'Advance personalized healthcare through AI-powered wellness solutions and evidence-based digital health. We decode healing pathways to deliver intelligent health systems that make precision wellness accessible through data-driven interventions.',
      cta: 'Elevate Wellbeing',
      accent: '#c9a84c',
    },
  ];

  return (
    <section id="services" className="py-28" style={{ background: 'linear-gradient(180deg, #09090f 0%, #0d0d1a 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{ color: '#c9a84c' }}>
            What We Do
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6 tracking-tight">
            AI-Powered <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 600 }}>Strategic Solutions</span>
          </h2>
          <p className="text-lg text-white/45 max-w-2xl mx-auto font-light leading-relaxed">
            Transforming industries through intelligent systems that illuminate possibilities, innovate processes, and elevate human potential
          </p>
        </div>

        {/* Banner */}
        <div className="mb-20 relative overflow-hidden" style={{ borderRadius: '16px', border: '1px solid rgba(201,168,76,0.2)' }}>
          <img
            alt="Éclat-Gen AI Innovation Hub"
            className="w-full h-72 object-cover object-center"
            src="https://public.readdy.ai/ai/img_res/d2b0ea57ce3ae251ef31d1f32aaeb0f6.jpg"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(9,9,15,0.7) 0%, rgba(9,9,15,0.3) 50%, rgba(9,9,15,0.6) 100%)' }} />

          {/* Floating badges */}
          {[
            { icon: 'ri-dna-line', title: 'Digital Biology', sub: 'AI Drug Discovery', pos: 'top-6 left-6' },
            { icon: 'ri-robot-2-line', title: 'Digital Transformation', sub: 'AI Automation', pos: 'top-6 right-6' },
            { icon: 'ri-heart-pulse-line', title: 'Digital Wellness', sub: 'AI Health Solutions', pos: 'bottom-6 left-6' },
          ].map((b) => (
            <div
              key={b.title}
              className={`absolute ${b.pos} flex items-center gap-3 px-4 py-3`}
              style={{ background: 'rgba(9,9,15,0.88)', backdropFilter: 'blur(16px)', borderRadius: '8px', border: '1px solid rgba(201,168,76,0.25)' }}
            >
              <div className="w-8 h-8 flex items-center justify-center" style={{ background: 'rgba(201,168,76,0.15)', borderRadius: '6px' }}>
                <i className={`${b.icon} text-sm`} style={{ color: '#c9a84c' }} />
              </div>
              <div>
                <div className="text-xs font-semibold text-white/90 tracking-wide">{b.title}</div>
                <div className="text-xs" style={{ color: '#c9a84c' }}>{b.sub}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Service Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="p-8 transition-all duration-300 group cursor-pointer"
              style={{
                background: 'rgba(255,255,255,0.02)',
                border: '1px solid rgba(201,168,76,0.12)',
                borderRadius: '12px',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.background = 'rgba(201,168,76,0.05)';
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(201,168,76,0.3)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.background = 'rgba(255,255,255,0.02)';
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(201,168,76,0.12)';
              }}
            >
              <div className="mb-6 flex items-center justify-between">
                <div className="w-14 h-14 flex items-center justify-center" style={{ background: 'rgba(201,168,76,0.1)', borderRadius: '10px', border: '1px solid rgba(201,168,76,0.2)' }}>
                  <i className={`${svc.icon} text-2xl`} style={{ color: '#c9a84c' }} />
                </div>
                <span className="text-xs font-semibold tracking-[0.15em] uppercase px-3 py-1" style={{ background: 'rgba(201,168,76,0.08)', color: '#c9a84c', borderRadius: '3px', border: '1px solid rgba(201,168,76,0.15)' }}>
                  {svc.tag}
                </span>
              </div>
              <h3 className="text-xl font-semibold text-white/90 mb-3 tracking-wide">{svc.title}</h3>
              <p className="text-sm text-white/45 mb-6 font-light leading-relaxed">{svc.desc}</p>
              <button className="flex items-center gap-2 text-sm font-semibold tracking-wide transition-all duration-300 group-hover:gap-3" style={{ color: '#c9a84c' }}>
                {svc.cta} <i className="ri-arrow-right-line" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
